const MARKETINGURL = 'https://www.focusvision.com/our-applications/'

export default [
  {
    title: 'Decipher',
    description:
      'Decipher is the online survey and reporting solution for ' +
      'insights pros who need to execute sophisticated quantitative research.',
    link: `${MARKETINGURL}#decipher`,
    linkText: 'Learn more',
    group: 'surveys-and-reporting'
  },
  {
    title: 'KinesisPanel',
    description:
      'Deploy automated processes and advanced tools that ' +
      'recruit, retain, reward, and report for superior panel management',
    link: `${MARKETINGURL}#kinesis-panel`,
    linkText: 'Learn more',
    group: 'surveys-and-reporting'
  },
  {
    title: 'Revelation',
    description:
      'Capture deeper, more informed qualitative insights in less ' +
      'time than ever, through advanced technology that helps you get to the ' +
      'heart of the consumer.',
    link: `${MARKETINGURL}#revelation`,
    linkText: 'Learn more',
    group: 'digital-qual'
  },
  {
    title: 'Live Video',
    description:
      'Capture and stream customer discussions with real-time ' +
      'access and team collaboration. Includes FV360 Live and FV Classic Live.',
    link: `${MARKETINGURL}#live-video`,
    linkText: 'Learn more',
    group: 'digital-qual'
  },
  {
    title: 'InterVu',
    description:
      'Live, two-way audio/video allows moderators and ' +
      'respondents in multiple locations to still interact face-to-face.',
    link: `${MARKETINGURL}#intervu`,
    linkText: 'Learn more',
    group: 'digital-qual'
  },
  {
    title: 'Video Insights',
    description:
      'Efficiently manage and leverage video to deliver more ' +
      'impact for teams and stakeholders.',
    link: `${MARKETINGURL}#video-insights`,
    linkText: 'Learn more',
    group: 'video-management'
  },
  {
    title: 'ResearchReporter',
    description:
      'Manage resources, projects, and knowledge to maximize ' +
      'budgets, minimize effort, and elevate your business.',
    link: `${MARKETINGURL}#research-reporter`,
    linkText: 'Learn more',
    group: 'video-management'
  }
]



// WEBPACK FOOTER //
// ./src/config/platformEntries.js